<template>
	<b-navbar class="auction-data bg-grey top navbar-auction" :sticky="true">
		<b-table-simple class="d-lg-none w-100 my-0" borderless>
			<b-tr>
				<b-td><b>{{car.car_brand}}<br />{{car.car_model}}</b></b-td>
				<b-td class="text-center"><b>¿Cúando?</b><br/><small>{{car.auction.auction_date |  moment("utc", "DD-MM-YYYY [a las] HH:mm")}}</small></b-td>
				<b-td class="text-center"><b-button size="sm" class="text-center px-4" variant="macal" :href="'https://www.macal.cl/Carro/AbonoNuevaWebOnline?autocavid='+car.operational_id" >Inscríbete</b-button></b-td>
			</b-tr>
			<b-tr v-if="car.auction" class="hide-on-top text-center bg-white">
				<b-td colspan="2">
					<b>Datos remate</b>
				</b-td>
			</b-tr>
			<b-tr v-if="car.auction" class="hide-on-top text-center bg-white">
				<b-td>
					<font-awesome-icon :icon="['fal', 'stopwatch']" /> {{car.auction.auction_date | moment("utc", "DD-MM-YYYY HH:mm")}}
				</b-td>
				<b-td>
					<font-awesome-icon :icon="['fal', 'map-marker-alt']" /> {{car.storage.address}}
				</b-td>
			</b-tr>
			<b-tr class="hide-on-top text-center bg-white">
				<b-td colspan="2">
					<b-button variant="outline-dark" size="sm">
						<font-awesome-icon :icon="['fal', 'download']" /> Descargar Loteo
					</b-button>
				</b-td>
			</b-tr>
		</b-table-simple>
		<b-table-simple v-if="car.auction" class="d-none d-lg-table w-100 my-0" borderless>
			<b-tr>
				<!--
				<b-td class="show-on-top show-on-scroll d-none" width="15%">
					<table class="auction-table">
						<tr>
							<td class="py-0" >
								<b>{{car.car_brand}}<br />{{car.car_model}}</b>
							</td>
						</tr>
						<tr>
							<td v-if="car.auction" class="py-2 text-middle">
								<span v-if="car.price">($ {{car.price | numberFormat}})</span><span v-else="">Próximamente</span>
							</td>
						</tr>
					</table>
				</b-td>
				-->
				<b-td>
					<table>
						<tr>
							<td class="text-right p-0 text-middle" rowspan="2" >
								<font-awesome-icon :icon="['fal', 'stopwatch']" size="2x" />
							</td>
							<td class="py-0">
								<b>Cuándo?</b>
							</td>
						</tr>
						<tr>
							<td v-if="car.auction" class="py-1 text-top">
								<span>{{car.auction.auction_date | moment("utc", "DD-MM-YYYY [a las] HH:mm")}}</span>
							</td>
						</tr>
					</table>
				</b-td>
				<b-td>
					<table>
						<tr>
							<td class="text-right p-0 text-middle" rowspan="2" >
								<font-awesome-icon :icon="['fal', 'map-marker-alt']" size="2x" />
							</td>
							<td class="py-0">
								<b>Dónde?</b>
							</td>
						</tr>
						<tr>
							<td v-if="car.auction" class="py-1 text-middle">
								Macal.cl
							</td>
						</tr>
					</table>
				</b-td>
				<b-td>
					<table>
						<tr>
							<td class="text-right p-0 text-middle" rowspan="2" >
								<font-awesome-icon :icon="['fal', 'street-view']" size="2x" />
							</td>
							<td class="py-0">
								<b>Conócelo</b>
							</td>
						</tr>
						<tr>
							<td class="py-1 text-top">
								Macal.cl
							</td>
						</tr>
					</table>
				</b-td>
				<b-td>
					<table>
						<tr>
							<td class="text-right p-0 text-middle" rowspan="2" >
								<font-awesome-icon :icon="['fal', 'file-alt']" size="2x" />
							</td>
							<td class="py-0">
								<b>Descarga Documentos</b>
							</td>
						</tr>
						<tr>
							<td v-if="car.auction" class="py-1 text-top">
								<b-link :href="car.auction.general_base_pdf_url" style="text-decoration: underline"  target="_blank">Bases</b-link>
								<b-link :href="car.auction.process_pdf_url" class="ml-2" style="text-decoration: underline"  target="_blank">Procedimiento</b-link>
							</td>
						</tr>
					</table>
				</b-td>
				<b-td>
					<table>
						<tr>
							<td class="text-right p-0 text-middle text-right" rowspan="2" >
								<font-awesome-icon :icon="['fal', 'video']" size="2x" />
							</td>
							<td class="py-0">
								<b>Como rematar online</b>
							</td>
						</tr>
						<tr>
							<td v-if="car.auction" class="py-1 text-top">
								<b-link style="text-decoration: underline" v-b-modal.modal-cuidemonos>Ver aquí</b-link>
							</td>
						</tr>
					</table>
				</b-td>
				<!--
				<b-td>
					<table>
						<tr>
							<td colspan="2" class="py-0 text-center">
								<b class="show-on-scroll d-none">Participa</b>
								<b class="hide-on-scroll">Participa en el remate</b>
							</td>
						</tr>
						<tr>
							<td class="py-2 text-middle">
								<b-button class="text-center" block variant="macal" :href="'https://www.macal.cl/Carro/AbonoNuevaWebOnline?autocavid='+car.operational_id">Inscríbete</b-button>
							</td>
							<td class="py-2 text-middle text-center">
								<b-button class="text-center" block variant="macal" v-b-modal.modal-cuidemonos><b-img class="hide-on-scroll" src="images/cuidemonos/play.png" width="15px" /> Aprende</b-button>
							</td>
						</tr>
					</table>
				</b-td>
				-->
			</b-tr>
		</b-table-simple>
	</b-navbar>
</template>

<script>
  export default {
	name: 'v-auction-detail',
	props: {
		car: {}
	},
	mounted(){
		window.addEventListener('scroll', function() {
			if(document.querySelector('.show-on-scroll') !== null){
				if(pageYOffset > 200){
					document.querySelectorAll('.show-on-scroll').forEach((elem)=> {
						elem.classList.remove("d-none")
					});
				}else{
					document.querySelectorAll('.show-on-scroll').forEach((elem)=> {
						elem.classList.add("d-none");
					});
				}
			}
			if(document.querySelector('.hide-on-scroll') !== null){
				if(pageYOffset > 200){
					document.querySelectorAll('.hide-on-scroll').forEach((elem)=> {
						elem.classList.add("d-none")
					});
				}else{
					document.querySelectorAll('.hide-on-scroll').forEach((elem)=> {
						elem.classList.remove("d-none")
					});
				}
			}
		});
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@media (max-width: 1400px){
		.auction-data{
			font-size: .8rem;
		}
	}
	.auction-data.top .fa-3x{
		font-size: 1.2rem;
	}
	.auction-data.top .hide-on-top{
		display: none;
	}
	.auction-data .show-on-top{
		display: none;
	}
	.auction-data.top .show-on-top{
		display: table-cell;
	}
	.auction-data.top td{
		padding-top: 0;
		padding-bottom: 0;
	}
	.auction-data.top .head{
		padding-bottom: .5rem;
	}
	.auction-data.top .btn-lg{
		padding-top: 0.1rem;
		padding-bottom: 0.1rem;
		font-size: 0.875rem;
		line-height: 1.5;
		border-radius: 0.2rem;
	}
</style>
